import styled from 'styled-components';
import { colors } from '../../assets/colors/index.tsx';

export const Container = styled.div`
  background: rgba(250, 246, 240, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 1.25rem;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.5rem;
`;

export const MenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 190, 152, 0.1);
  }
`;

export const LogoTitle = styled.h1`
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: ${colors.quaternary};
  text-align: center;
  flex: 1;
  font-family: 'Cormorant Garamond', serif;
  letter-spacing: -0.01em;
  cursor: pointer;
`;